import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ambikapur-chess-tournament',
  templateUrl: './ambikapur-chess-tournament.component.html',
  styleUrls: ['./ambikapur-chess-tournament.component.scss']
})
export class AmbikapurChessTournamentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
